import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister"
import type {
  AsyncStorage,
  Persister,
} from "@tanstack/query-persist-client-core"

export interface CreateQueryPersisterOptions {
  /**
   * The storage client used for persisting the query cache. Accepts both
   * synchronous storages (e.g. `window.localStorage`) and asynchronous ones
   * (e.g. React Native's `AsyncStorage`).
   */
  storage: AsyncStorage<string> | undefined | null
  /** The key to use when storing the cache. */
  key: string
  /**
   * To avoid spamming, pass a time in ms to throttle saving the cache to
   * storage.
   */
  throttleTime?: number
}

/**
 * Creates a TanStack Query persister backed by the given storage engine.
 * Consuming apps should use this instead of depending on
 * `@tanstack/query-async-storage-persister` directly, keeping that
 * dependency an internal implementation detail of `@mimber/client`.
 */
export const createQueryPersister = ({
  storage,
  key,
  throttleTime,
}: CreateQueryPersisterOptions): Persister =>
  createAsyncStoragePersister({ storage, key, throttleTime })
